<script lang="ts">
import { defineComponent } from "vue"
import Modal from "@/components/Modal.vue"
import { ConfirmationActionType } from "@/types/data"
import ThemedLoading from "@/components/ThemedLoading.vue"

export default defineComponent({
    name: "LocationInviteConfirmed",
    components: { ThemedLoading, Modal },
    props: {
        confirmationId: { type: Number, required: true },
    },
    emits: ["close"],
    data() {
        return {
            isLoading: true,
            isConfirmed: null,
            location: null,
        }
    },
    mounted() {
        this.isLoading = true
        this.axios
            .post("/security/validate-confirmation", {
                data: {
                    id: this.confirmationId,
                    action: ConfirmationActionType.LOCATION_INVITE,
                },
            })
            .then((response) => {
                const data = response.data.data

                this.location = data.location
                this.isConfirmed = true
            })
            .catch(({ response }) => {
                const errorMessage = response.data.error.message

                this.isConfirmed = false
            })
            .finally(() => {
                this.isLoading = false
            })
    },
    methods: {
        onContinue() {
            this.$emit("close")
        },
    },
})
</script>

<template>
    <Modal :title="$t('location_invite.location_added_title')">
        <template #body>
            <ThemedLoading :active="isLoading" :is-full-page="false" :opacity="0.95" />
            <div v-if="isConfirmed" class="text-center">
                <span class="fa-solid fa-house-circle-check fa-4x text-success mb-4"></span>

                <p class="text-success">
                    {{
                        $t("location_invite.location_added_text", {
                            locationName: location.name,
                        })
                    }}
                </p>
            </div>
            <div v-else-if="isConfirmed === false" class="text-center">
                <span class="fa-solid fa-xmark-circle fa-4x text-danger mb-4"></span>

                <p class="text-danger">{{ $t("location_invite.error") }}</p>
            </div>
            <button class="btn btn-block btn-primary" @click="onContinue">
                {{ $t("location_invite.continue") }}
            </button>
        </template>
    </Modal>
</template>
